/**
 * 未分配产康安排：在 SingleProjectAppointmentForm 上接「未分配计划」与确认排期提交
 *（桌面新订单、手机 newOrdersDispatchMobile 均经 MaternityCenterDispatcherContent 使用本面板）
 */
import React, { useRef, useState } from 'react'
import PropTypes from 'prop-types'
import { Button, message, Empty } from 'antd'
import dayjs from 'dayjs'
import { assignProjectPlanTechnician } from '@/service/dispatchPage'
import {
  extractErrorMessage,
  isValidServiceMinutes,
  normalizeServiceMinutes,
  parseTechnicianIdForApi
} from '@/utils/renderUtils'
import { planServiceMinutes } from '@/utils/unassignedPlanTimeInit'
import SingleProjectAppointmentForm from './SingleProjectAppointmentForm'

const UnassignedProjectPlanBookPanel = (props) => {
  const { plan, storeId, onSuccess, technicianValue, useMobileDatePicker, mobileUaDevice } = props
  const formRef = useRef()
  const [submitting, setSubmitting] = useState(false)

  const serviceMinutes = planServiceMinutes(plan)
  const hasValidServiceTime = isValidServiceMinutes(
    normalizeServiceMinutes(serviceMinutes)
  )
  const serviceM = normalizeServiceMinutes(serviceMinutes)

  const handleSubmit = async () => {
    if (!hasValidServiceTime) {
      message.error('服务时长无效')
      return
    }
    const f = formRef.current
    if (!f?.validateFields) return
    let fields
    try {
      fields = await f.validateFields()
    } catch (e) {
      if (e?.errorFields) return
      return
    }
    const dateValue = fields.appointmentDate
    const dateStr = typeof dateValue?.format === 'function'
      ? dateValue.format('YYYY-MM-DD')
      : String(dateValue || '')
    const appointmentDate = dateStr ? +dayjs(dateStr).startOf('day') : null
    const startTimeStr = (fields.appointmentStartTime || '').trim()
    const startTime = startTimeStr ? +dayjs(`${dateStr} ${startTimeStr}`) : null
    const endTime = startTime != null ? +dayjs(startTime).add(serviceM, 'minute') : null
    const technicianId = parseTechnicianIdForApi(fields.technicianId)
    if (technicianId == null) {
      message.error('请选择有效的产康师')
      return
    }
    setSubmitting(true)
    try {
      await assignProjectPlanTechnician(plan.id, {
        technicianId,
        appointmentDate: appointmentDate != null ? appointmentDate : undefined,
        startTime: startTime != null ? startTime : undefined,
        endTime: endTime != null ? endTime : undefined
      })
      message.success('已保存排期')
      if (typeof onSuccess === 'function') onSuccess()
    } catch (e) {
      message.error(extractErrorMessage(e, '提交失败'))
    } finally {
      setSubmitting(false)
    }
  }

  if (!storeId) {
    return (
      <Empty
        description="未指定门店，无法加载产康师"
        image={Empty.PRESENTED_IMAGE_SIMPLE}
      />
    )
  }

  return (
    <div className="unassigned-plan-book-style">
      <div className="single-project-appointment-form unassigned-project-plan-book-form">
        <SingleProjectAppointmentForm
          form={formRef}
          storeId={storeId}
          serviceTime={serviceMinutes}
          technicianValue={technicianValue}
          unassignedPlan={plan}
          useMobileDatePicker={!!useMobileDatePicker}
          mobileUaDevice={mobileUaDevice}
        />
        <Button
          type="primary"
          onClick={handleSubmit}
          loading={submitting}
          block
        >
          确认排期
        </Button>
      </div>
    </div>
  )
}

UnassignedProjectPlanBookPanel.propTypes = {
  plan: PropTypes.object.isRequired,
  storeId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onSuccess: PropTypes.func,
  /** 责任产康师标签：优先 order-total 详情 `technicians`；否则用 GET /project-plan/unassigned 行上 `technicians`（`{id,name}`） */
  technicianValue: PropTypes.array,
  /** 新订单·手机 H5：预约日期用大尺寸、只读防弹键盘、日历挂 body */
  useMobileDatePicker: PropTypes.bool,
  /** 由 UA（navigator.userAgent）解析是否常见移动设备；false 时 PC 打开嵌入页强制 antd 日期框 */
  mobileUaDevice: PropTypes.bool
}

export default UnassignedProjectPlanBookPanel
